"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _billButtons = _interopRequireDefault(require("@/views/userCenter/componens/billButtons.vue"));
var _index2 = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _searchFile = require("@/api/searchFile/searchFile");
var _fileButtons = _interopRequireDefault(require("@/views/infoSearch/fileButtons.vue"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "searchFile",
  components: {
    Pagination: _index.default,
    FileButtons: _fileButtons.default,
    filterColumn: _index2.default,
    billButtons: _billButtons.default
  },
  data: function data() {
    return {
      loading: null,
      searchForm: {
        companyName: '',
        fileName: ''
      },
      tableData: [],
      hotSettings: {
        dragCheck: true,
        height: 'auto',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: false,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      listQuery: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  mounted: function mounted() {
    this.searchFormData();
  },
  methods: {
    resetForm: function resetForm() {
      this.searchForm = {
        companyName: '',
        fileName: ''
      };
    },
    searchFn: function searchFn() {
      this.listQuery.currentPage = 1;
      this.searchFormData();
    },
    searchFormData: function searchFormData() {
      var _this = this;
      this.searchForm.companyName = this.searchForm.companyName.trim();
      this.searchForm.fileName = this.searchForm.fileName.trim();
      var data = this.searchForm;
      data.pageStart = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      this.loading = (0, _utils.load)();
      (0, _searchFile.getWebGuaranteeQuery)(data).then(function (res) {
        _this.tableData = res.data.records;
        _this.listQuery.total = res.data.totalRecord;
      }).catch(function (err) {}).finally(function () {
        _this.loading.close();
      });
    },
    handleDownload: function handleDownload(row) {
      var _this2 = this;
      this.loading = (0, _utils.load)();
      (0, _searchFile.getFileDownload)(row).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res]));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', res.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(function (err) {}).finally(function () {
        _this2.loading.close();
      });
    }
  }
};